import client from '@common/utils/rest';

const URL_PREFIX = 'api/userMaintenance';

export const getEmailConfirmationStatus = () => {
  return client({
    path: `${URL_PREFIX}/emailconfirmation`,
    method: 'GET',
  }).then((response) => response.entity);
};

export const confirmEmail = (email) => {
  return client({
    path: `${URL_PREFIX}/emailconfirmation`,
    method: 'POST',
    entity: email,
  });
};
